import React from "react";
import "../../../../../css/games/funMatka/title.css" 
import funMatka_timer from "../../../../../../assets/titles/indie/matkaTimer.svg";

export default function Title(props){
    return<div className="fd text-center">
    <img className='titleImg matkaTitle' src={funMatka_timer} alt={funMatka_timer}></img>
    </div>
}